import { render } from "./MateriaisUtilizados.vue?vue&type=template&id=388d1bae"
import script from "./MateriaisUtilizados.vue?vue&type=script&lang=js"
export * from "./MateriaisUtilizados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__